/**
 * Asynchronously loads the component for Register
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
